import React, { useState } from 'react';
import { ALPHABET } from '../../../utils/constants';

export const MultipleChoiceOption = ({activeRadio, completed, getOptionMods, name, option, index, handleChange}) => {

  const [focused, setFocused] = useState(false);

  return (
    <div className="task__option-wrapper">
      <label className={`task__option ${getOptionMods(index)}${focused ? ' task__option--focused' : ''}`}>
        <span className="task__option-letter">{ALPHABET[index]}</span>
        <span className="task__option-text">{option._}</span>
        <input
          type="radio"
          name={name}
          checked={activeRadio === index}
          disabled={completed}
          onChange={() => handleChange(index)}
          onFocus={() => setFocused(true)}
          onBlur={() => setFocused(false)}
        />
        <span aria-hidden="true"></span>
      </label>
    </div>
  )
}